import { patientApi } from "@mgdx/api/lib/patientApi";
import { Patient } from "@mgdx/shared/src/models/Patient";
import { handleApiError } from "@mgdx-libs/error-handler";
import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { patientKeys } from "../../factories";
import { setCurrentUser } from "../../stores/currentUserStore";
import { isSamePatient, startUpdatingPatient, UpdatingPatient } from "./currentPatientQuery";

export type ApiResponseData = Patient;
type ApiError = Error;
type ApiRequestVariables = void;

type MutationOptions = Omit<
  UseMutationOptions<ApiResponseData, ApiError, ApiRequestVariables, UpdatingPatient>,
  "mutationFn" | "onSuccess" | "onError" | "onMutate"
>;

export const useUpdateAgreementMutation = (options?: MutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponseData, ApiError, ApiRequestVariables, UpdatingPatient>({
    mutationFn: () =>
      patientApi.putAgreement({ putPatientAgreementRequestBody: { agreement: true } }).catch(handleApiError),
    onMutate: startUpdatingPatient,
    onSuccess: (data, _, context) => {
      // 更新中に別の患者へ切り替わった場合は、前の患者の応答を書き込まない
      if (!isSamePatient(context)) return;

      queryClient.invalidateQueries({
        queryKey: patientKeys.patient.current.queryKey,
      });
      setCurrentUser(data);
    },
    ...options,
  });
};
